/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import {Component, HostListener, computed, inject, input} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { merge } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { OptionSingleSelectionService } from '../../option/selection/signle-selection/option-single-selection.service';
import { SelectComponent } from '../select.component';
import {SelectInputComponent} from "@ng-falcon/controls/select/select-input/select-input.component";
import {DisplayValuePipe} from "@ng-falcon/controls/option/display-value.pipe";

@Component({
  selector: 'ngf-single-select,ngf-single-select[small]',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss'],
  imports: [
    SelectInputComponent,
    DisplayValuePipe,
  ]
})
export class SingleSelectComponent {

  showOverflowTooltip = input(false);

  ariaLabel = input<string>();

  ariaLabelledby = input<string>();

  ariaDescribedby = input<string>();

  protected select = inject(SelectComponent);

  private optionService = inject(OptionSingleSelectionService);

  readonly value = computed(() => this.optionService.selection().value);

  readonly showClear = computed(() => this.select.clearable
    && !this.select.disabled
    && !this.select.isReadonly
    && (this.select.nullAsValue ? this.value() !== undefined : (!!this.value() || this.value() === false || this.value() === 0)));

  constructor() {
    merge(
      this.handleSelectionChange$(),
      this.handleWrittenValueChanged$()
    ).pipe(takeUntilDestroyed()).subscribe();
  }

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.select.optionsOverlay.toggle();
  }

  handleBlur() {
    this.select.onTouched();
  }

  handleClear(): void {
    this.optionService.clear({ userInput: true });
  }

  private handleSelectionChange$() {
    return this.optionService.selection$.pipe(
      filter(selection => selection.userInput),
      tap(selection => {
        this.select.handleSelection(selection.value);
        this.select.optionsOverlay.close();
        this.focusSelectInput();
      })
    );
  }

  private focusSelectInput(): void {
    const inputElement = this.select.elementRef.nativeElement.querySelector('input');
    inputElement?.focus();
  }

  private handleWrittenValueChanged$() {
    return this.select.writtenValue$.pipe(
      tap(value => this.optionService.select({value, userInput: false}))
    );
  }
}
